export const CreateField = ({
  fieldType = 1,
  fieldValue,
  parentHandleChange,
  isSubmitted,
  config,
}) => {
  const checkEmptyfield = () => {
    if (isSubmitted) {
      if (
        fieldValue === "" ||
        fieldValue === null ||
        fieldValue === undefined
      ) {
        return "empty"
      }
      if (
        config.type === "email" &&
        fieldValue &&
        !fieldValue.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)
      ) {
        return "empty"
      }
      if (fieldType === 3 && fieldValue === false) {
        return "empty"
      }
    }
    return ""
  }

  const handleChange = (event) => {
    const { name, value } = event.target
    if (config.type === "number") {
      const pattern = /^[0-9]*$/

      if (pattern.test(value)) {
        parentHandleChange(name, value)
      } else {
        console.log(" no")
      }
      return
    }
    console.log("s")
    parentHandleChange(name, value)
  }

  return (
    <div
      className={`d-flex flex-column ${
        config.fieldWidth ? config.fieldWidth : "w-100"
      } form-field ${checkEmptyfield()}`}
    >
      <label className="label-field" htmlFor={config.inputID}>
        {config.labelText}
      </label>
      {fieldType === 1 && (
        <input
          id={config.inputID}
          name={config.inputID}
          className="input-field"
          autoComplete="off"
          maxLength={config.maxLength ? config.maxLength : 150}
          type={config.type ? config.type : "text"}
          onChange={handleChange}
          value={fieldValue}
        />
      )}
      {fieldType === 2 && (
        <select
          id={config.inputID}
          name={config.inputID}
          className="input-field"
          onChange={parentHandleChange}
          value={fieldValue}
        >
          <option></option>
          {config.options?.map((option, index) => (
            <option key={index} value={option.value}>
              {option.name}
            </option>
          ))}
        </select>
      )}
    </div>
  )
}
